




















/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { register } from 'register-service-worker'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import { Alert } from '@finx/web-repository/src/types/Alert'
import Env from '@finx/web-repository/src/services/Env'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Factories } from '@finx/web-repository'
import StatusStore from '@finx/web-repository/src/stores/Status'
import AssinaturaStore from '@/store/Assinaturas'
import store from '../store'

const component: Object = {
  store: {
    AssinaturaStore,
    StatusStore,
  },
}

@Component(component)

export default class ViewRedirect extends Vue {
  stores: any = {
    assinaturas: (this.$store as any).AssinaturaStore,
    status: (this.$store as any).StatusStore,
  }

  alert: Alert = {
    show: false,
    buttons: [],
    icon: '',
    iconColor: '',
    subtitle: '',
    title: '',
  }

  user = {} as any
  terms: Boolean = false

  assinatura: any = {}

  get isAssinaturaDemonstacao() {
    return AssinaturaStore.getters.ASSINATURA_DEMONSTRACAO
  }

  mounted() {
    this.getUser()
  }

  async checkServiceWorker() {
    const serviceWorkerEnvEnable = Env.ENV === 'development'
    const serviceWorkerUrl = `${Env.CLIENT_ADDRESS}/service-worker.js`

    const serviceWorker = new Promise((resolve, reject) => {
      if (serviceWorkerEnvEnable) {
        register(serviceWorkerUrl, {
          updatefound() {
            resolve('/alerta/atualizacao-encontrada')
          },
        })
      } else {
        resolve()
      }
    })

    serviceWorker
      .then((redirectTo) => {
        if (redirectTo) this.redirect(redirectTo)
        else this.getUser()
      })
      .catch(() => {
        this.getUser()
      })
  }

  async getUser() {
    if (this.$user) {
      // IMPORTANTE: Se há impersonação ativa, NÃO verificar expiração
      // O token do usuário personificado pode estar "expirado" mas ainda é válido
      const isImpersonating = sessionStorage.getItem('IMPERSONATION_ACTIVE')

      if (isImpersonating === 'true') {
        console.warn('⚠️ Impersonação ativa - pulando verificação de expiração')
        this.checkTerms()
        return
      }

      const now = Math.floor(Date.now() / 1000)
      const isTokenExpired = Number(this.$user.expiresAt) < now
      if (isTokenExpired) {
        this.redirect('/inicio')
      } else {
        this.checkTerms()
      }
    } else {
      this.redirect('/inicio')
    }
  }

  async checkTerms() {
    const request = await ApiLegacy.Terms.getTermsStatus()
    const success = Factories.Apis.success(request)

    if (success) this.terms = request.data

    if (this.terms) this.getAssinatura()
    else this.redirect('/aceite')
  }

  async getAssinatura() {
    const request = await ApiPlans.Assinatura.getAssinatura(true)
    const success = request.status || request.response.status === 200

    if (success) {
      this.assinatura = request.data.value
      await this.checkSubscription()
    } else this.redirect('/planos')
  }

  async checkSubscription() {
    const { status, tipoAssinatura, statusPagamento, usuarioPagante, plano } = this.assinatura

    if (this.isAssinaturaDemonstacao) {
      this.redirect('/calculadora')
    } else if (status === 'Ativa'
      && (this.assinatura.planos !== undefined
      && this.assinatura.planos !== null
      && this.assinatura.planos.length === 1
      && this.assinatura.planos.some(p => p.chave === 'plano_calculadora'))) {
      this.redirect('/calculadora')
    } else if (status === 'Ativa'
     && tipoAssinatura === 'Paga'
     && statusPagamento === 'Processado'
     && usuarioPagante) {
      this.redirect('/dashboard')
    } else if (status === 'Ativa'
    && tipoAssinatura === 'Paga'
    && statusPagamento === 'EmProcessamento'
    && usuarioPagante) {
      this.redirect('/dashboard')
    } else if (status === 'Ativa'
    && tipoAssinatura === 'Paga'
    && statusPagamento === 'Pendente'
    && usuarioPagante) {
      this.showAlert('pagamento-pendente')
    } else if (status === 'Ativa'
    && tipoAssinatura === 'Free'
    && statusPagamento === 'Processado') {
      this.redirect('/dashboard')
    } else if (status === 'Ativa'
    && tipoAssinatura === 'Paga'
    && !usuarioPagante) {
      this.redirect('/dashboard')
    } else if (status === 'Criada'
    && tipoAssinatura === 'Paga'
    && statusPagamento === 'Pendente'
    && usuarioPagante) {
      this.redirect('/pagamento/ativar')
    } else if (status === 'Criada'
    && tipoAssinatura === 'Paga'
    && statusPagamento === 'Pendente'
    && !usuarioPagante) {
      this.showAlert('assinatura-nao-ativada')
    } else if (status === 'Bloqueada') {
      this.showAlert('assinatura-bloqueada')
    } else if (status === 'Cancelada') {
      this.showAlert('assinatura-cancelada')
    } else {
      this.redirect('/dashboard')
    }
  }

  showAlert(alert) {
    switch (alert) {
      case 'assinatura-cancelada':
        this.alert.buttons = [
          {
            text: 'Sair',
            action: '/logout',
            color: 'primary',
            flat: true,
          },
        ]
        this.alert.icon = 'warning'
        this.alert.iconColor = 'warning'
        this.alert.subtitle = 'Sua conta foi cancelada. Entre em contato com nosso suporte para mais detalhes em: contato@finxapp.com.br'
        this.alert.title = 'Assinatura cancelada'
        this.alert.show = true
        break

      case 'assinatura-nao-ativada':
        this.alert.buttons = [
          {
            text: 'Sair',
            action: '/logout',
            color: 'primary',
            flat: true,
          },
        ]
        this.alert.icon = 'report'
        this.alert.iconColor = 'primary'
        this.alert.subtitle = 'Sua conta ainda não foi ativada.'
        this.alert.title = 'Acesso indisponível'
        this.alert.show = true
        break

      case 'assinatura-bloqueada':
        this.alert.buttons = [
          {
            text: 'Regularizar',
            action: '/pagamento/regularizar',
            color: 'primary',
          },
          {
            text: 'Sair',
            action: '/logout',
            color: 'primary',
            flat: true,
          },
        ]
        this.alert.icon = 'block'
        this.alert.iconColor = 'error'
        this.alert.subtitle = 'Sua conta está bloqueada. Regularize o pagamento para continuar usando o aplicativo.'
        this.alert.title = 'Assinatura bloqueada'
        this.alert.show = true
        break

      case 'pagamento-pendente':
        this.alert.buttons = [
          {
            text: 'Regularizar',
            action: '/pagamento/regularizar',
            color: 'primary',
          },
          {
            text: 'Depois',
            action: '/dashboard',
            color: 'primary',
            flat: true,
          },
        ]
        this.alert.icon = 'money_off'
        this.alert.iconColor = 'error'
        this.alert.subtitle = 'Regularize sua forma de pagamento para continuar usando o aplicativo'
        this.alert.title = 'Pagamento pendente'
        this.alert.show = true
        break

      default:
        break
    }
  }

  redirect(url): void {
    this.$router.push(url)
  }

  showStatus(acao, texto, textoAcao) {
    this.stores.status.commit('ACAO', acao)
    this.stores.status.commit('ATIVO', true)
    this.stores.status.commit('SHOW', true)
    this.stores.status.commit('TEXTO', texto)
    this.stores.status.commit('TEXTO_ACAO', textoAcao)
  }
}
